import { gatewayPhone } from "../../../../../../../../gateways/gatewayPhone";

interface GetAvailableUsPhoneNumbersParams {
    areaCode?: string;
    limit?: number;
}

export const getAvailableUsPhoneNumbers = async ({
    areaCode,
    limit = 5,
}: GetAvailableUsPhoneNumbersParams = {}): Promise<PhoneNumber[]> => {
    const response = await gatewayPhone.get<PhoneNumber[]>(
        "/twilio/phone-numbers/us/available",
        {
            params: {
                smsEnabled: true,
                voiceEnabled: true,
                mmsEnabled: true,
                ...(areaCode ? { areaCode } : {}),
                limit,
            },
        },
    );

    return response?.data ?? [];
};